export const TERMINAL_CONTACT_EMAIL_KEY = "operationsContactEmail";
export const RE_BUILDING_CATEGORY_KEY = "commercialRealEstateCategory";
export const AREA_KEY = "area";
export const TERMINAL_TYPE = "TERMINAL";
export var RealEstateCategory;
(function (RealEstateCategory) {
    RealEstateCategory["Office"] = "officebuilding";
    RealEstateCategory["ShoppingCenter"] = "shoppingcenter";
    RealEstateCategory["Pecunia"] = "officebuilding_pecunia_notrack";
    RealEstateCategory["IndustrialPark"] = "industrialpark";
})(RealEstateCategory || (RealEstateCategory = {}));
//# sourceMappingURL=constants.js.map